import cb1 from './cb1.txt'
import cb2 from './cb2.txt'
import cb3 from './cb3.txt'
import cb4 from './cb4.txt'
import cb5 from './cb5.txt'
import cb6 from './cb6.txt'

const blocks = {
    cb1: cb1,
    cb2: cb2,
    cb3: cb3,
    cb4: cb4,
    cb5: cb5,
    cb6: cb6,
}

export default blocks